import React from "react";
import ModalNew from "../Modal";
import PopupHeader from "../common/popupHeader";
import PopupContent from "../common/PopupContent";
import PopupSection from "../common/PopupSection";

function TrendingNewsModal({ item, setIsModalOpen }) {
  if (!item) return null;

  const { title, image, description, source_name, source_link } = item;

  return (
    <ModalNew className="content-modal">
      <PopupHeader setOpenState={setIsModalOpen} />

      <PopupContent>
        {image && (
          <div className="news-popup-image-container">
            <img src={image} alt={title} className="news-popup-image" />
          </div>
        )}

        <PopupSection>
          <div className="news-popup-body">
            {title && <h3 className="news-popup-title">{title}</h3>}

            {description && (
              <p className="news-popup-description">{description}</p>
            )}

            {source_link && (
              <div className="news-popup-actions">
                <a
                  href={source_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cta-button primary rounded"
                >
                  <b>Go to Source</b>
                </a>
              </div>
            )}
          </div>
        </PopupSection>
      </PopupContent>
    </ModalNew>
  );
}

export default TrendingNewsModal;
